<span class="popup-header">Rechnungsdokument:</span>
<a *ngFor="let attachment of attachments" [href]="attachment.FullUrl" target="_blank">
    {{attachment.FileName}}
</a>
